export const theme = {
  breakpoints: ['40em', '52em', '64em'],
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64],
  colors: {
    text: '#000',
    background: '#fff',
    primary: '#074078',
    secondary: '#0e75c4',
    muted: '#f6f6f6',
    gray: '#EFF2F6',
    danger: '#fef3f4',
    // danger: ['#e90c22', '#fef3f4'],
    divider: '#DDDDDD',
    input: '#868B98',
    disabledLight: '#d3d3d34f',
    disabledDark: '#8080803d',
    greys: ['#F6F8FA', '#8E949F'],
    'black': '#000000',
    'blueGrey': '#828fa6',
    'darkGreyOutline': '#868b98',
    'shadow': '#bec2c7',
    'disabledButton': '#949494',
    'disabledText': '#6e6e6e',
    'disabledBackground': '#EFF2F6',
    'disabledBorder': '#e5e7ea',
    'errorBorder': '#e90c22',
    'errorText': '#e90c22',
    'errorBackground': '#fef3f4',
    'grayOutline': '#949494',
    'greysB': ['#f6f8fa', '#f6f8fa', '#dfe4ea', '#8e949f'],
    'success': '#54a654',
    'successFill': '#e5f5e2',
    'visitedLink': '#884488',
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    body: '"PT Sans", sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    heading: 'inherit',
    monospace: 'Menlo, monospace'
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25,
    section: 3,
    input: 2
  },
  shadows: {
    small: '0 0 4px rgba(0, 0, 0, .125)',
    large: '0 0 24px rgba(0, 0, 0, .125)',
  },
  root: {
  },
  "button-group": {
    bg: 'muted'
  },
  buttons: {
      primary: {
        color: "background",
        background: "primary",
        border: `solid`,
        borderColor: 'primary',
        ':hover': {
          cursor: 'pointer'
          // background: '#40a9ff'
        },
        ':active': {
          background: '#074078',
          borderColor: '#074078'
        },
        ':disabled': {
          backgroundColor: 'disabledBackground',
          borderColor: 'disabledBorder',
          cursor: 'default'
        },
        outlined: {
          border: `solid`,
          background: 'none',
          borderWidth: '1px',
          borderColor: 'primary',
          color: 'primary',
          py: '10px',
          ':hover': {
            cursor: 'pointer'
            // background: '#40a9ff'
          },
        },
        text: {
          color: 'primary',
          background: 'none',
          fontWeight: 'bold',
          py: '10px',
          ':hover': {
            cursor: 'pointer'
            // background: '#40a9ff'
          },
        }
      },
    secondary: {
        color: 'primary',
        background: 'none',
        outline: {
          background: "none",
          color: 'primary',
          border: '2px solid primary'
        }
    }
  },
  switch: {
    primary: {
      bg: 'primary',
      color: 'background'
    },
    disabled: {
      opacity: 'none'
    }
  },
  wysiwig: {
    minHeight: '100px',
    '.ql-editor': {
      minHeight: '200px'
    },
    disabled: {
      '.quill': {
        pointerEvents: 'none',
      },
      '.ql-editor': {
        pointerEvents: 'none',
        minHeight: '200px',
        backgroundColor: 'disabledBackground',
        borderColor: 'disabledBorder'
      },
    },
    error: {
      '.ql-editor': {
        minHeight: '200px',
        backgroundColor: 'errorBackground',
        borderColor: 'errorBorder'
      }
    }
  },
  radio: {
    "&:focus": {
      background: 'none'
    }
  },
  'input=*[type="radius"]': {
    background: 'danger[0]'
  },
  'tenant-table': {
    width: '100%',
    borderCollapse: "collapse",
    'tr > th:first-child': {
      textAlign: 'left',
      justifyContent: 'left',
    },
    'tr > td:last-child': {
      textAlign: 'center'
    },
    'th, td': {
      borderBottom: '1px solid #ddd'
     },
    th: {
      bg: '#DFE4EA'
    },
    actions: {
      textAlign: 'center',
      background: 'primary'
    }
  },
  header: {
    gridTemplateAreas: `
      '.hamburger logo . notifications profile dropdown',
      'crumbs'
      'title actions'
    `,
    gridTemplateColumns: 'max-content max-content 1fr max-content max-content max-content',
    minHeight: 72,
    alignItems: 'center',
    gridArea: 'content',
  },
  colorSample: {
    width: '50px',
    height: '50px',
    borderRadius: '100px',
    border: `solid`,
    borderWidth: '1px',
    borderColor: 'muted',
  },
  layout: {
    gridTemplateAreas: `'hhhh hhhh hhhh' '. bbbb .'`,
    gridTemplateColumns: 'auto minmax(auto, 1120px) auto',
    gridTemplateRows: 'max-content',
    gridRowGap: 0,
    minHeight: '100%',
    height: 'auto',
    'header': {
      gridTemplateColumns: 'auto minmax(auto, 1120px) auto',
      background: 'background',
      gridArea: 'hhhh',
      gridTemplateAreas: `
        '. content .' 
        'divider divider divider' 
        '. crumbs .' 
        '. controls .'
      `,
      boxShadow: "0px 4px 4px 0px #DDDDDD",
      zIndex: 1,
      divider: {
        gridArea: 'divider',
      },
      'bread-crumbs': {
        py: 3,
        gridArea: 'crumbs'
      },
      'form-controls': {
        py: 3,
        gridArea: 'controls'
      }
    },
    'body': {
      gridArea: 'bbbb'
    }
  },
  breadcrumbs: {
    alignItems: 'center'
  },
  box: {
    form: {
      disabled: {
        backgroundColor: 'black'
      }
    }
  },
  forms: {
    px: 97,
    py: 47,
    "& :not(:last-child)": {
      py: 4,
      borderBottom: '1px solid lightgray'
    },
    input: {
      borderColor: 'input',
      lineHeight: 'input',
      // background: 'black',
      ":focus": {
        background: 'none',
        lineHeight: 'input',
      },
      ":hover": {
        "borderColor": "primary",
        lineHeight: 'input',
      },
      "error": {
        backgroundColor: 'errorBackground',
        borderColor: 'errorBorder',
        lineHeight: 'input',
      },
      "disabled": {
        color: 'disabledText',
        lineHeight: 'input',
        pointerEvents: 'none',
        borderColor: 'disabledBorder',
        backgroundColor: 'disabledBackground'
      }
    },
    checkbox: {
      primary: {
        color: 'background',
      }
    },
    dropZone: {
      bg: 'disabledBackground',
      radii: 3,
      p: 4
    },
    field: {
      label: {
        mb: 12
      }
    },
    switch: {},
    radio: {
      disabled: {
        active: {
          'path': {
            opacity: 0.5,
          }
        },
        '&:checked > path': {
          color: 'disabledBorder',
        },
      }
    },
    fieldset: {
      border: "none",
      padding: 12
    }
  },
  label: {
    switch: {
      fontSize: 2,
      color: 'red'
    },
    radio: {
      fontSize: 2,
      color: 'red'
    },
    default: {
      fontWeight: 'bold'
    }
  },
  popover: {
    boxShadow: '1px 6px 5px #DFE4EA',
    borderRadius: '4px',
    p: 3,
    minWidth: '150px',
    'a': {
      textDecoration: 'none'
    }
  },
  text: {
    switch: {
      fontSize: 2,
    },
    radio: {
      fontSize: 2
    },
    default: {
      color: 'text',
      fontSize: 3,
    },
    legend: {
      color: 'primary',
      fontWeight: 'bold',
      fontSize: 4,
      lineHeight: 'section'
    },
    heading: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      lineHeight: 'heading',
      letterSpacing: 'heading',
    },
    label: {
      color: 'text',
      fontWeight: 'bold'
    },
    section: {
      fontWeight: 'bold',
      fontSize: 4,
      lineHeight: 'section'
    },
    display: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      lineHeight: 'heading',
      letterSpacing: 'heading',
      fontSize: [5, 6, 7],
    },
    caps: {
      textTransform: 'uppercase',
      letterSpacing: 'caps',
    },
    error: {
      backgroundColor: '#ffeeee',
      borderRadius: '4px',
      color: '#cc0000',
      fontWeight: 'bold',
      padding: '10px;'
    }
  },
  scrollToTop: {
    left: 0,
    right: 0,
    justifyContent: 'flex-end',
    position: 'fixed',
    width: '100%',
    bottom: '20px',
    zIndex: 2,
    padding: 1,
    pr: 3,
    height: 40,
  },
  styles: {
    root: {
      fontFamily: 'body',
      lineHeight: 'body',
      fontWeight: 'body',
    },
    h1: {
      variant: 'text.heading',
      fontSize: 5,
    },
    h2: {
      variant: 'text.heading',
      fontSize: 4,
    },
    h3: {
      variant: 'text.heading',
      fontSize: 3,
    },
    h4: {
      variant: 'text.heading',
      fontSize: 2,
    },
    h5: {
      variant: 'text.heading',
      fontSize: 1,
    },
    h6: {
      variant: 'text.heading',
      fontSize: 0,
    },
    pre: {
      fontFamily: 'monospace',
      overflowX: 'auto',
      code: {
        color: 'inherit',
      },
    },
    code: {
      fontFamily: 'monospace',
      fontSize: 'inherit',
    },
    table: {
      width: '100%',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    th: {
      textAlign: 'left',
      borderBottomStyle: 'solid',
    },
    td: {
      textAlign: 'left',
      borderBottomStyle: 'solid',
    }
  }
};
